import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { lastValueFrom } from 'rxjs';
import { Injectable } from "@angular/core";
import { UserService } from "./user.service";
import { UtilityService } from "./utility.service";

@Injectable()
export class SettingsService{

    constructor( private _http: HttpClient,private userSrv:UserService, private utilService:UtilityService ){}

    public getSettings(settings:string[]):Promise<{settingId:number,settingKey:string,settingValue:string}[]>{
        return new Promise((resolve, reject)=>{
            this.getAllSettings().then((data:any)=>{
                let returnSettings:{settingId:number,settingKey:string,settingValue:string}[] = []
                data.forEach((setting:any)=>{
                    settings.forEach((val)=>{
                        if(setting.settingKey === val){
                            returnSettings.push(setting)
                        }
                    })
                });
            resolve(returnSettings);;
            }).catch((err)=>{
                reject(err);
            })
        })
    }

    private getAllSettings():Promise<void>{
        let username = this.userSrv.getUserName();
        let token = this.userSrv.getUserToken();
        return new Promise((resolve, reject)=>{
            let result = lastValueFrom(this._http.get(this.utilService.getBaseUrl()+'Settings/getall?username='+username+"&token="+token ));
            result.then((data:any)=>{
                // this.cacheSettings = data;
                resolve(data)
            }).catch((error)=>{
                console.error(error);
                reject();
            })
        })
       
    }

    private postRequest(url:string, body:HttpParams){
        return this._http.post(url,body.toString(),{headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')})
    }
}